import ListNoResults from '@/modules/results/components/match/ListNoResults';
import ListResults from '@/modules/results/components/match/ListResults';
import { MatchHeader } from '@/modules/results/components/match/MatchHeader';
import { MatchInfo } from '@/modules/results/components/match/MatchInfo';
import { MatchPlayers } from '@/modules/results/components/match/MatchPlayers';
import { MatchPropsShort, PlayerMatchesHistoryInfoModalArgs } from '@/modules/results/types';

interface MatchCardProps {
  match: MatchPropsShort;
  isHistory?: boolean;
  prevMatchesIds?: string[] | null;
  playerMatchesArgs?: PlayerMatchesHistoryInfoModalArgs;
  shouldFetchPrevMatches?: boolean;
  setOpenMatchUUID?: React.Dispatch<React.SetStateAction<string>>;
  pbracketsURL?: string;
}

export const MatchCard = ({
  match,
  isHistory = false,
  prevMatchesIds,
  playerMatchesArgs,
  shouldFetchPrevMatches,
  setOpenMatchUUID = () => {},
  pbracketsURL,
}: MatchCardProps) => {
  return (
    <div className='mt-4 w-full rounded-lg border bg-white'>
      <MatchHeader
        match={match}
        isHistory={isHistory}
        setOpenMatchUUID={setOpenMatchUUID}
        pbracketsURL={pbracketsURL}
      />
      <div className='flex flex-row overflow-x-auto'>
        <div className='min-w-max flex-1'>
          <div className='flex h-1/2 justify-between border-b'>
            <MatchPlayers match={match} team={1} />
            {match.match_status === 1 ? (
              <ListNoResults id={match.match_uuid} gameNo={match.score_format_game_best_out_of} />
            ) : (
              <ListResults match={match} team={1} />
            )}
          </div>
          <div className='flex h-1/2 justify-between'>
            <MatchPlayers match={match} team={2} />
            {match.match_status === 1 ? (
              <ListNoResults id={match.match_uuid} gameNo={match.score_format_game_best_out_of} />
            ) : (
              <ListResults match={match} team={2} />
            )}
          </div>
        </div>
        {!isHistory && (
          <div className='hidden items-center justify-center border-l sm:flex'>
            <MatchInfo match={match} />
          </div>
        )}
      </div>
      {!isHistory && (
        <div className='sm:hidden'>
          <MatchInfo match={match} />
        </div>
      )}

      {isHistory ? (
        <div>
          <MatchInfo
            match={match}
            isHistory={isHistory}
            prevMatchesIds={prevMatchesIds}
            playerMatchesArgs={playerMatchesArgs}
            shouldFetchPrevMatches={shouldFetchPrevMatches}
          />
        </div>
      ) : null}
    </div>
  );
};
